import "primeicons/primeicons.css"; //icons
import { Button } from "primereact/button";
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import { bool, func } from 'prop-types';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import useWindowDimensions from "../hooks/useDimensions";
import './Burger.css';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Burger
Description : Botón encargado de desplegar el menú lateral de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el botón desde cero
================================================================================ */

const Burger = ({ open, setOpen }) => {

    const location = useLocation();
    const { height, width } = useWindowDimensions()

    // useEffect(() => {
    //     if (width < 675) {
    //         setOpen(!open)
    //     }
    // }, [width])

    if (location.pathname.match(/Login/) || location.pathname.match(/Register/) || location.pathname.match(/CompleteRegister/) || location.pathname.match(/Logout/)) {
        return null;
    }

    return (
        <Button className="burgerButton" icon="pi pi-bars" style={{ marginTop: !localStorage.getItem("logo") || width <= 675 ? "0.3rem" : "0.6rem" }} open={open} onClick={() => setOpen(!open)} />
    )

}

Burger.propTypes = {
    open: bool.isRequired,
    setOpen: func.isRequired,
}

export default Burger;